/**
 * Provider Types
 *
 * Central definition for an investment Provider record and the admin-editable
 * `data` JSON column (PWA-2335). The backend persists `data` as an arbitrary
 * nullable JSON object; for now the only key the UI reads/writes is `tier`.
 */

// Access tier stored on the provider's `data` JSON. Machine tokens are the
// source of truth; labels are display-only (PROVIDER_TIER_OPTIONS).
export type ProviderTier = "full_access" | "academy";

export const PROVIDER_TIER_OPTIONS: { value: ProviderTier; label: string }[] = [
  { value: "full_access", label: "Full Access" },
  { value: "academy", label: "Academy" },
];

/**
 * Arbitrary JSON metadata attached to a provider. Currently only `tier` is
 * surfaced in the UI; the shape is intentionally open at the backend.
 */
export interface ProviderData {
  tier?: ProviderTier;
}

export interface Provider {
  id: string;
  name: string;
  logoUrl?: string;
  data?: ProviderData | null;
  createdAt: string;
  updatedAt: string;
}
